import { SupportedLanguagesEnum } from 'Constants/locale'

const FALLBACK_PRIORITY: readonly SupportedLanguagesEnum[] = [
  SupportedLanguagesEnum.DE,
  SupportedLanguagesEnum.EN,
  SupportedLanguagesEnum.FR,
]

/**
 * Picks the highest-priority language available to the current organisation,
 * following the DE \> EN \> FR order. Returns
 * `null` only when no language is enabled at all (which the upstream config
 * should never allow), giving callers a chance to no-op rather than crash.
 */
export const pickFallbackLanguage = (
  enabledLanguages: ReadonlySet<SupportedLanguagesEnum>,
): SupportedLanguagesEnum | null => {
  for (const language of FALLBACK_PRIORITY) {
    if (enabledLanguages.has(language)) {
      return language
    }
  }

  return null
}
